import React from 'react';
import PrivacyPageBody from '../components/PrivacyPageBody';

function PrivacyPage() {
    return <PrivacyPageBody />;
}

export default PrivacyPage;